/* eslint-disable-next-line */
export interface DataVisualizationProps {}

export function DataVisualization(props: DataVisualizationProps) {
  return <div></div>;
}

export default DataVisualization;
